import { MDSCardSlotName, MDSCardVariant } from "./card.types";
import type { IMDSCardProps } from "./card.types";
import {
  StyledButton,
  StyledCardContent,
  StyledCardHeader,
  StyledCardIcon,
  StyledCardRightAddon,
  StyledCardTitle,
  StyledCardDescription,
  StyledButtonContent,
  StyledCard,
} from "./card.style";
import { getSlots, getUnslottedChildren } from "@/mds/utils/slots";
import { MDSTextVariant, MDSTextWeight } from "@/mds/components/text";
import { MDSIcon } from "@/mds/components/icon";

export function MDSCard(props: IMDSCardProps) {
  const {
    onPress,
    className,
    variant = MDSCardVariant.Default,
    children: _children,
    ...rest
  } = props;

  if (onPress) {
    return (
      <StyledButton
        {...rest}
        className={className}
        $variant={variant}
        onPress={onPress}
        data-mds-name="card"
      >
        <Content {...props} />
      </StyledButton>
    );
  }

  return (
    <StyledCard
      aria-label={props["aria-label"]}
      className={className}
      $variant={variant}
      data-mds-name="card"
    >
      <Content {...props} />
    </StyledCard>
  );
}

const Content = (props: IMDSCardProps) => {
  const { mdsIcon, title, description, children } = props;

  const rightAddon = getSlots(children, MDSCardSlotName.RightAddon);
  const content = getSlots(children, MDSCardSlotName.Content);
  const unslottedContent = getUnslottedChildren(children);

  const hasRightAddon = rightAddon.length > 0;
  const hasHeader = Boolean(mdsIcon || title || hasRightAddon);
  const hasContent = content.length > 0 || unslottedContent.length > 0;

  return (
    <StyledButtonContent>
      {hasHeader && (
        <StyledCardHeader>
          {mdsIcon && (
            <StyledCardIcon>
              {typeof mdsIcon === "function" ? mdsIcon() : <MDSIcon kind={mdsIcon} />}
            </StyledCardIcon>
          )}
          {title && (
            <StyledCardTitle variant={MDSTextVariant.HeaderS} weight={MDSTextWeight.SemiBold}>
              {title}
            </StyledCardTitle>
          )}
          {hasRightAddon && <StyledCardRightAddon>{rightAddon}</StyledCardRightAddon>}
        </StyledCardHeader>
      )}
      <div>
        {description && (
          <StyledCardDescription variant={MDSTextVariant.ParagraphS}>
            {description}
          </StyledCardDescription>
        )}
        {hasContent && <StyledCardContent>{[...content, ...unslottedContent]}</StyledCardContent>}
      </div>
    </StyledButtonContent>
  );
};
